(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-flash-deal-timer"] && !Shopify.designMode) return;
  try {
    class CsFlashTimer extends HTMLElement {
    #tid = null;
    #endTime = 0;

    connectedCallback() {
      const pad = (n) => String(n).padStart(2, '0');
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
      const parts = fmt.formatToParts(new Date());
      const y = parts.find(p => p.type === 'year').value;
      const mo = parts.find(p => p.type === 'month').value;
      const d = parts.find(p => p.type === 'day').value;
      const isPDT = new Date(`${y}-${mo}-${d}T12:00:00-07:00`)
        .toLocaleString('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', hour12: false }) === '12';
      const offset = isPDT ? '-07:00' : '-08:00';
      this.#endTime = new Date(`${y}-${mo}-${d}T23:59:59${offset}`).getTime();

      const timeEl = this.querySelector('.cs-flash-timer__time');
      if (!timeEl) return;

      const tick = () => {
        const diff = this.#endTime - Date.now();
        if (diff <= 0) {
          this.style.display = 'none';
          clearInterval(this.#tid);
          return;
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        timeEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
      };

      tick();
      this.#tid = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.#tid);
    }
  }

  if (!customElements.get('cs-flash-timer')) {
    customElements.define('cs-flash-timer', CsFlashTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-member-atc"] && !Shopify.designMode) return;
  try {
    class CsMemberAtc extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller = new AbortController();
      this.addEventListener('submit', this.#onSubmit, { signal: this.#controller.signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #onSubmit = async (event) => {
      event.preventDefault();

      const button = this.querySelector('[data-cs-member-cta]');
      const variantId = Number(this.dataset.variantId);
      if (!button || !variantId || button.hasAttribute('disabled')) return;

      const sellingPlan = Number(this.dataset.sellingPlan);
      const original = button.textContent;
      button.setAttribute('disabled', '');

      try {
        // The cart can change in the drawer after this page rendered, so the
        // Liquid check alone is not enough. Re-read it every time.
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        const alreadyIn = cart.items.some((item) => item.variant_id === variantId);

        if (alreadyIn) {
          this.#reflectInCart();
          this.#openCart();
          return;
        }

        const item = { id: variantId, quantity: 1, properties: { _inveterate_subscription: 'true' } };
        if (sellingPlan) item.selling_plan = sellingPlan;

        const added = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        const result = await added.json();

        if (result.status) {
          button.textContent = original;
          button.removeAttribute('disabled');
          return;
        }

        // Every CTA on the page reflects the new state, not just the one clicked.
        for (const el of document.querySelectorAll('cs-member-atc')) el.reflectInCart();
        this.#openCart();
      } catch {
        button.textContent = original;
        button.removeAttribute('disabled');
      }
    };

    reflectInCart() {
      this.#reflectInCart();
    }

    #reflectInCart() {
      const button = this.querySelector('[data-cs-member-cta]');
      if (!button) return;
      this.setAttribute('data-in-cart', '');
      button.textContent = this.dataset.labelInCart || 'Already in your cart';
      // Stays disabled: the membership is in the cart and cannot be added twice.
      button.setAttribute('disabled', '');
    }

    #openCart() {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'cs-member-atc',
            data: { source: 'product-form-component', itemCount: 1 },
          },
        })
      );
    }
  }

  if (!customElements.get('cs-member-atc')) {
    customElements.define('cs-member-atc', CsMemberAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
